
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookFallCoordinates",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "api/Form/loadForm",
      apiSaveMethod: "",
      form: "WildbuchEintragFallwild",
      page: "WildbuchEintragLokalisierungFallwild",
      remoteId: "",
      waitForResponse: true,
      geoEditMode: "New",
      geoGpsMode: "OnStartup",
      geoDisplayClass: "additional",
      geoCheckInsidePolygon: true,
     


    });
    return {
      request
    };
  }
};
